import tw from 'twin.macro';

import { TrashIcon } from '@heroicons/react/24/outline';
import { UseFormRegister, FieldErrors } from 'react-hook-form';

import { TemplateFormValues } from '../types';

type Props = {
  index: number;
  register: UseFormRegister<TemplateFormValues>;
  errors: FieldErrors<TemplateFormValues>;
  isViewOnly: boolean;
  onRemove: () => void;
};

const QuestionForm = ({ index, register, errors, isViewOnly, onRemove }: Props) => {
  const q = `questions.${index}` as const;

  return (
    <div tw="border border-gray-200 rounded-xl p-4 bg-gray-50 flex flex-col gap-3">
      <div tw="flex items-center justify-between">
        <span tw="text-sm font-semibold text-gray-700">คำถามที่ {index + 1}</span>
        {!isViewOnly && (
          <button
            type="button"
            tw="p-1.5 rounded-lg text-gray-400 hover:(text-red-500 bg-red-50) transition-colors duration-100"
            onClick={onRemove}
            title="ลบคำถาม"
          >
            <TrashIcon tw="w-4 h-4" />
          </button>
        )}
      </div>

      <label tw="flex flex-col gap-1">
        <span tw="text-sm font-medium text-gray-700">คำถาม *</span>
        <input
          tw="rounded-lg border bg-white px-3 py-2 text-sm focus:(outline-none ring-1 ring-primary) disabled:bg-gray-100"
          placeholder="กรอกคำถาม"
          disabled={isViewOnly}
          {...register(`${q}.title`, { required: 'กรุณากรอกคำถาม' })}
        />
        {errors.questions?.[index]?.title && (
          <span tw="text-red-500 text-xs">{errors.questions[index]?.title?.message}</span>
        )}
      </label>

      <label tw="flex flex-col gap-1 w-32">
        <span tw="text-sm font-medium text-gray-700">เวลา (วินาที) *</span>
        <input
          type="number"
          min={1}
          tw="rounded-lg border bg-white px-3 py-2 text-sm focus:(outline-none ring-1 ring-primary) disabled:bg-gray-100"
          placeholder="60"
          disabled={isViewOnly}
          {...register(`${q}.duration`, {
            required: 'กรุณากรอกเวลา',
            valueAsNumber: true,
            min: { value: 1, message: 'ต้องมากกว่า 0' },
          })}
        />
        {errors.questions?.[index]?.duration && (
          <span tw="text-red-500 text-xs">{errors.questions[index]?.duration?.message}</span>
        )}
      </label>

      <label tw="flex flex-col gap-1">
        <span tw="text-sm font-medium text-gray-700">คำแนะนำ (คั่นด้วยเครื่องหมายจุลภาค)</span>
        <input
          tw="rounded-lg border bg-white px-3 py-2 text-sm focus:(outline-none ring-1 ring-primary) disabled:bg-gray-100"
          placeholder="เช่น พูดถึงประสบการณ์, อธิบายขั้นตอน"
          disabled={isViewOnly}
          {...register(`${q}.tips`)}
        />
      </label>
    </div>
  );
};

export default QuestionForm;
